import React from 'react';

const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold mb-4">Terms of Service</h1>
        <p className="text-slate-600 mb-8">Last updated: {new Date().toLocaleDateString()}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Acceptance of Terms</h2>
        <p className="mb-4">
          By accessing or using <strong>moujib.com</strong> (the "Service"), you agree to be
          bound by these Terms of Service (the "Terms"). If you use the Service on behalf of an
          organization, you represent that you have authority to bind that organization and its
          authorized Facebook Pages and Instagram accounts.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Service Description</h2>
        <p className="mb-4">
          moujib.com is a SaaS platform for comment moderation on Facebook Pages and Instagram
          professional accounts. The Service enables you to configure and perform actions such as
          deleting spam comments, hiding comments, replying publicly, sending private replies (DM)
          where supported, and applying rule‑based automations for moderation.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Accounts & Eligibility</h2>
        <p className="mb-4">
          You are responsible for safeguarding your account credentials and for all activity under
          your account. You must have the necessary rights to connect and manage any Facebook Page
          or linked Instagram professional account through the Service.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Facebook & Instagram Permissions & Integrations</h2>
        <p className="mb-4">
          When you connect your Facebook profile, you grant the Service the minimum permissions
          needed to identify and access Pages you administer, along with any Instagram professional
          (Business or Creator) accounts linked to those Pages. When you subsequently connect a
          Facebook Page or Instagram account, you grant additional permissions required to perform
          moderation actions (including reading and managing comments, hiding or deleting comments,
          replying publicly, and sending messages where supported) in accordance with your
          configuration, the Meta Platform Terms, and the Facebook and Instagram Platform Policies.
          You may revoke permissions at any time via your Facebook or Instagram settings; doing so may
          limit or disable related features.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Moderation Actions</h2>
        <ul className="list-disc ml-6 space-y-2">
          <li>Delete spam or unwanted comments (where allowed by the Facebook and Instagram APIs).</li>
          <li>Hide comments from public view.</li>
          <li>Reply publicly to comments or send private replies (DM) where supported by the platform.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-2">Rule‑Based Automations</h2>
        <p className="mb-4">
          You can create rules that automatically take moderation actions based on criteria you
          define. You are solely responsible for your configurations and for reviewing their impact.
          The Service executes actions per your rules and settings; you remain the controller of
          those actions and their outcomes.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Acceptable Use</h2>
        <ul className="list-disc ml-6 space-y-2">
          <li>Do not use the Service to violate Meta (Facebook and Instagram) policies or any applicable law.</li>
          <li>Do not engage in harassment, abuse, or unlawful content or targeting.</li>
          <li>Do not attempt to circumvent rate limits or disrupt the Service.</li>
          <li>Only act on Pages, Instagram accounts, and data you are authorized to manage.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-2">AI‑Generated Content & Limitations</h2>
        <p className="mb-4">
          If you enable AI assistance, outputs may be inaccurate, incomplete, or inappropriate.
          You are responsible for reviewing and approving messages and actions sent under your brand.
          The Service does not guarantee detection of all spam or policy‑violating content.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Data & Privacy</h2>
        <p className="mb-4">
          We process data as described in our Privacy Policy available at <a className="text-primary underline" href="/privacy">/privacy</a>.
          We use access tokens solely to perform the actions you authorize. You may disconnect your
          integrations at any time; some data may be retained as required by law or for security and
          audit purposes.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Termination</h2>
        <p className="mb-4">
          We may suspend or terminate the Service (or your access) if you violate these Terms,
          pose a security or legal risk, or fail to pay applicable fees (if any). You may stop using
          the Service at any time.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Disclaimer & Limitation of Liability</h2>
        <p className="mb-4">
          The Service is provided on an "as is" and "as available" basis without warranties of any
          kind. To the maximum extent permitted by law, moujib.com is not liable for indirect,
          incidental, special, consequential, or punitive damages, or any loss of profits, data, or
          goodwill, arising from or related to your use of the Service.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-2">Contact</h2>
        <p className="mb-4">For questions about these Terms, contact khalil@moujib.com.</p>
      </div>
    </div>
  );
};

export default TermsOfService; 